import React, { ReactNode } from 'react';
import cx from 'classnames';
import { Layout } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useLocation } from 'react-router-dom';

import { SettingsNavigationBar } from '../common/navigationBar/settingsNavigationBar';
import { Breadcrumb } from '../common/breadcrumb';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

import styles from './dashboard.module.scss';

const isBillingUserFacingEnabled = isFeatureEnabled(Features.BillingUserFacing);

interface LayoutProps {
  children: ReactNode;
  actions?: ReactNode[];
}

const { Header } = Layout;
const COMPARE_SLUG = 'compare';
const PLAN_AND_BILLING_SLUG = 'plan-billing';

export const SettingsDashboard: React.FC<LayoutProps> = ({ children, actions }) => {
  const location = useLocation();
  const currentPath = location?.pathname;
  const isOnCompare = currentPath?.includes(COMPARE_SLUG);
  const isOnPlanAndBilling = isBillingUserFacingEnabled && currentPath?.includes(PLAN_AND_BILLING_SLUG);

  const actionsSection = actions && <div className={styles.actionsContainer}>
    {actions.map((action, index) => (
      <div className={styles.action} key={`${index}-header-action`}>
        {action}
      </div>
    ))}
  </div>;

  const getRoutes = (path: string) => {
    const pathSections = path.split('/');
    const isSubscriptionPage = pathSections[2] === 'subscription';
    const isNestedRoute = pathSections.length === 4;
    const lastRoute = pathSections.pop() || '';
    if (!['edit', 'compare'].includes(lastRoute)) {
      return [];
    }
    if (isSubscriptionPage && isNestedRoute) {
      return [
        {
          key: 'subscription',
          path: '/subscription',
          absolutePath: '/settings/subscription',
          breadcrumbName: 'Current plan'
        },
        {
          key: 'current',
          path: '/',
          breadcrumbName: lastRoute === 'edit' ? 'Edit subscription' : 'Explore plans'
        }
      ];
    }
    return [];
  };

  const routes = getRoutes(location.pathname);

  const header =
    <div className={styles.header}>
      <div className={styles.title}>
        Account Settings
        <Breadcrumb routes={routes} />
      </div>
      <Header className={styles.dashboardHeader}>
        <div className={cx(styles.subHeader, {
          [styles[Features.PlgExternal3]]: isFeatureEnabled(Features.PlgExternal3)
        })}>
          <SettingsNavigationBar />
          {actionsSection}
        </div>
      </Header>
    </div>;

  return (
    <div className={styles.dashboard}>
      {header}
      <Layout className={cx(styles.filterDrawerContainer, { [styles.withCompareContent]: isOnCompare || isOnPlanAndBilling })}>
        <Content className={styles.dashboardContent}>
          <main>{children}</main>
        </Content>
      </Layout>
    </div>
  );
};

